import { API_BASE_URL } from '..'

export interface FetchResponse<T> {
  status: number
  statusText: string
  body: T
  headers: any
  ok: boolean
}

export interface ApiFetchConfig {
  endpoint: string
  method: string
  accessToken?: string
  body?: any
  headers?: any
  //un-encoded uri paramters that gets appended to the url
  params?: {key: string, value: string}[]
  fileExtension?: string
  baseUrlOverride?: string
}

export async function apiFetch<T>(config: ApiFetchConfig): Promise<FetchResponse<T>> {
  const baseUrl = config.baseUrlOverride ?? API_BASE_URL
  const url = `${baseUrl}/${config.endpoint}`
  config.headers = {
    ...config.headers,
    'Authorization': `Bearer ${config.accessToken}`
  }

  let parameters = config.params
  let params = ''
  if(parameters){
    params = `?${parameters.map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`).join('&')}`
  }

  const response = await fetch(`${url}${params}`, {
    body: config.body,
    headers: config.headers,
    method: config.method,
    
  })

  let returnBody = await response.text()
  try{
    returnBody = JSON.parse(returnBody)
  }catch(error){
    // return body is not json
  }

  return {
    body: returnBody as T,
    headers: response.headers,
    status: response.status,
    statusText: response.statusText,
    ok: response.ok
  }
}

export async function apiFetchRaw<T>(config: ApiFetchConfig): Promise<FetchResponse<T>> {
  const url = `${API_BASE_URL}/${config.endpoint}`;
  config.headers = {
    ...config.headers,
    'Authorization': `Bearer ${config.accessToken}`
  };

  let params = '';
  if (config.params) {
    params = `?${config.params.map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`).join('&')}`;
  }

  const response = await fetch(`${url}${params}`, {
    body: config.body,
    headers: config.headers,
    method: config.method,
  });

  const contentType = response.headers.get('Content-Type') || '';
  let returnBody: any;

  const isBinary = ['pdf', 'xlsx'].includes(config.fileExtension || '');

  if (contentType.includes('application/json')) {
    returnBody = await response.json();
  } else if (isBinary) {
    const blob = await response.blob();
    returnBody = blob;
  } else {
    returnBody = await response.text();
  }

  return {
    body: returnBody as T,
    headers: response.headers,
    status: response.status,
    statusText: response.statusText,
    ok: response.ok
  };
}



export async function apiFetchBody<T>(config: ApiFetchConfig): Promise<T> {
  const response = await apiFetch<T>(config)
  return response.body
}
